"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploader = FileUploader;
/** @jsx jsx */
var core_1 = require("@emotion/core");
var react_1 = __importStar(require("react"));
var file_validator_1 = require("@cd2/file-validator");
var FileboyProvider_1 = require("../FileboyProvider");
var _Parts_1 = require("./_Parts");
var utils_1 = require("../utils");
var useTimeout_1 = require("../useTimeout");
function FileUploader(props) {
    var uploaderStyle = props.uploaderStyle;
    if (props.render && uploaderStyle) {
        (0, utils_1.warning)("FileUploader does not support both a render prop and uploaderStyle.");
    }
    if (!props.render && uploaderStyle === undefined) {
        uploaderStyle = "default";
    }
    var builtInRenderers = {
        minimal: MinimalRenderer,
        default: DefaultRenderer,
        buttonOnly: ButtonOnlyRenderer,
    };
    if (uploaderStyle && !(uploaderStyle in builtInRenderers)) {
        var builtInNames = Object.keys(builtInRenderers);
        (0, utils_1.warning)("unknown uploaderStyle \"".concat(uploaderStyle, "\" expected one of ").concat(builtInNames.join(",")));
        uploaderStyle = "default";
    }
    var setTimeout = (0, useTimeout_1.useTimeout)();
    var _a = (0, react_1.useState)(), error = _a[0], setError = _a[1];
    var _b = (0, react_1.useState)(props.defaultFileId), fileId = _b[0], setFileId = _b[1];
    var _c = (0, react_1.useState)(false), isUploading = _c[0], setIsUploading = _c[1];
    var _d = (0, react_1.useState)(false), visualUploadDelay = _d[0], setVisualUploadDelay = _d[1];
    var fileboy = (0, FileboyProvider_1.useFileboy)(props.namespace);
    var fileInputRef = (0, react_1.useRef)(null);
    var DropZone = (0, react_1.useMemo)(function () {
        return function (_a) {
            var children = _a.children, dropZoneProps = __rest(_a, ["children"]);
            return ((0, core_1.jsx)(_Parts_1.FileUploadContainer, __assign({ onDropFile: function (files) { return uploadFile(files[0]); } }, dropZoneProps), children));
        };
    }, []);
    function handleFileChange(e) {
        if (!e.target.files) {
            return;
        }
        var files = Array.from(e.target.files);
        uploadFile(files[0]);
    }
    function uploadFile(file, mime) {
        return __awaiter(this, void 0, void 0, function () {
            var fileData, name, metadata, data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (props.allow) {
                            if (!(0, file_validator_1.isFileAllowed)(file, props.allow)) {
                                setError("Disallowed file given");
                                return [2 /*return*/];
                            }
                        }
                        fileData = (0, utils_1.extractFileDataFromFile)(file);
                        name = props.fileName ? props.fileName(fileData) : file.name;
                        metadata = props.metadata ? props.metadata(fileData) : undefined;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        setIsUploading(true);
                        setVisualUploadDelay(true);
                        setTimeout(function () { return setVisualUploadDelay(false); }, uploaderStyle === "buttonOnly" ? 1000 : 250);
                        if (props.onUploadStart) {
                            props.onUploadStart();
                        }
                        return [4 /*yield*/, fileboy.uploadFile(file, {
                                name: name,
                                metadata: metadata,
                                mime: mime ? mime : undefined,
                            })];
                    case 2:
                        data = _a.sent();
                        if (props.onFileUploaded) {
                            props.onFileUploaded(data);
                        }
                        setFileId(data.id);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        setError(e_1.message);
                        return [3 /*break*/, 5];
                    case 4:
                        if (props.onUploadEnd) {
                            props.onUploadEnd();
                        }
                        setIsUploading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function openFileDialogue() {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }
    function handleRemoveFile() {
        if (props.onRemoveFile && fileId) {
            setFileId(undefined);
            props.onRemoveFile(fileId);
        }
    }
    var Render = props.render || builtInRenderers[uploaderStyle !== null && uploaderStyle !== void 0 ? uploaderStyle : "default"];
    return ((0, core_1.jsx)(react_1.default.Fragment, null,
        (0, core_1.jsx)("input", { ref: fileInputRef, key: fileId, type: "file", onChange: handleFileChange, accept: props.allow && Array.isArray(props.allow) ? props.allow.join(",") : props.allow, hidden: true }),
        (0, core_1.jsx)(Render, { error: error, id: fileId, openFileDialogue: openFileDialogue, uploadFileManually: uploadFile, isUploading: isUploading || visualUploadDelay, DropZone: DropZone, theme: props.theme, onRemoveFile: props.onRemoveFile ? handleRemoveFile : undefined })));
}
function MinimalRenderer(_a) {
    var _b, _c;
    var error = _a.error, id = _a.id, openFileDialogue = _a.openFileDialogue, DropZone = _a.DropZone, isUploading = _a.isUploading, theme = _a.theme, onRemoveFile = _a.onRemoveFile;
    return ((0, core_1.jsx)(DropZone, { inlineBlock: true },
        (0, core_1.jsx)("div", { css: (0, core_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          display: flex;\n          font-family: ", ";\n          align-items: center;\n          > * {\n            margin-right: 8px;\n          }\n        "], ["\n          display: flex;\n          font-family: ", ";\n          align-items: center;\n          > * {\n            margin-right: 8px;\n          }\n        "])), theme === null || theme === void 0 ? void 0 : theme.fontFamily) },
            (0, core_1.jsx)("div", null,
                (0, core_1.jsx)(_Parts_1.ErrorString, { string: error }),
                id ? ((0, core_1.jsx)("div", { className: "fileboy-preview", css: (0, core_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                padding: 8px 0;\n              "], ["\n                padding: 8px 0;\n              "]))) },
                    (0, core_1.jsx)(_Parts_1.PreviewFileName, { id: id, onRemoveFile: onRemoveFile }))) : ((0, core_1.jsx)(_Parts_1.UploadButton, { buttonColor: (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.button, buttonTextColor: (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.buttonText, onClick: openFileDialogue, value: isUploading ? "Uploading..." : "Upload File", disabled: isUploading }))))));
}
function ButtonOnlyRenderer(_a) {
    var _b, _c;
    var error = _a.error, openFileDialogue = _a.openFileDialogue, DropZone = _a.DropZone, isUploading = _a.isUploading, theme = _a.theme;
    return ((0, core_1.jsx)("div", { css: (0, core_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        font-family: ", ";\n        display: inline-block;\n      "], ["\n        font-family: ", ";\n        display: inline-block;\n      "])), theme === null || theme === void 0 ? void 0 : theme.fontFamily) },
        (0, core_1.jsx)(DropZone, { inlineBlock: true },
            (0, core_1.jsx)(_Parts_1.ErrorString, { string: error }),
            (0, core_1.jsx)(_Parts_1.UploadButton, { buttonColor: (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.button, buttonTextColor: (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.buttonText, onClick: openFileDialogue, value: isUploading ? "Uploading..." : "Upload File", disabled: isUploading }))));
}
function DefaultRenderer(_a) {
    var _b, _c;
    var error = _a.error, id = _a.id, openFileDialogue = _a.openFileDialogue, DropZone = _a.DropZone, isUploading = _a.isUploading, theme = _a.theme, onRemoveFile = _a.onRemoveFile;
    return ((0, core_1.jsx)("div", null,
        (0, core_1.jsx)(DropZone, { inlineBlock: true },
            (0, core_1.jsx)(_Parts_1.ErrorString, { string: error }),
            (0, core_1.jsx)(_Parts_1.DefaultRenderContainer, { fontFamily: theme === null || theme === void 0 ? void 0 : theme.fontFamily },
                (0, core_1.jsx)("div", { className: "fileboy-preview" }, id ? ((0, core_1.jsx)(_Parts_1.PreviewThumb, { key: "".concat(id), id: id, onRemoveFile: onRemoveFile })) : ((0, core_1.jsx)(_Parts_1.FileUploadPrompt, null))),
                (0, core_1.jsx)("div", { css: (0, core_1.css)("margin-top: 8px") }),
                isUploading ? ((0, core_1.jsx)(_Parts_1.SVGLoadingSpinner, null)) : ((0, core_1.jsx)("div", { css: (0, core_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                text-align: left;\n              "], ["\n                text-align: left;\n              "]))) },
                    (0, core_1.jsx)(_Parts_1.UploadButton, { buttonColor: (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.button, buttonTextColor: (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.buttonText, onClick: openFileDialogue, value: "Upload File" })))))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
